import {
  READINESS_CHECKLIST,
  checklistItemDone,
  type ServiceOfferingReadiness,
} from "./serviceSetupReadiness";

export function ServiceSetupReadinessChecklist(props: { readiness: ServiceOfferingReadiness }) {
  const { readiness } = props;
  return (
    <ul className="space-y-1 text-sm text-gray-700 dark:text-zinc-300">
      {READINESS_CHECKLIST.map((item) => {
        const done = checklistItemDone(item.key, readiness);
        return (
          <li key={item.key} className="flex items-center gap-2">
            <span className={done ? "text-emerald-600 dark:text-emerald-400" : "text-gray-400 dark:text-zinc-500"}>
              {done ? "✓" : item.blocking ? "○" : "○"}
            </span>
            <span className={done ? "" : item.blocking ? "" : "text-gray-500 dark:text-zinc-400"}>
              {item.label}
              {!item.blocking ? " (optional)" : ""}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
